import { render } from "./TipInfoTipper.vue?vue&type=template&id=5194b92b&scoped=true"
import script from "./TipInfoTipper.vue?vue&type=script&lang=js"
export * from "./TipInfoTipper.vue?vue&type=script&lang=js"

import "./TipInfoTipper.vue?vue&type=style&index=0&id=5194b92b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5194b92b"]])

export default __exports__